<!--
  GPE customization (gov.ao): the filters as a two column panel.

  The same panel the Rails list pages render (app/components/filter/
  filter_component.html.erb), built on the same classes so the two look and
  behave alike. Names on the left - the ones in use first, then the rest - and
  the selected one's controls on the right.

  The one difference is what picking an unused name does. On the Rails side
  every filter's pane is already in the page and selecting one only shows it.
  Here a filter has no instance until it is added, so picking it creates one.
  That does not change the query on its own: only filters with values are
  applied (replaceIfComplete), so an empty one filters nothing.
-->
<fieldset id="filters" *ngIf="filters" class="advanced-filters--container">
  <legend [textContent]="text.selected_filter_list"></legend>

  <button *ngIf="showCloseFilter"
          type="button"
          class="advanced-filters--reset"
          [attr.title]="text.reset_filters"
          (click)="reset()">
    <i class="advanced-filters--reset-icon icon-context icon-reload" aria-hidden="true"></i>
    <span class="advanced-filters--reset-text" [textContent]="text.reset_filters"></span>
  </button>

  <a *ngIf="showCloseFilter"
     [attr.title]="text.close_form"
     class="advanced-filters--close icon-context icon-close"
     (click)="closeFilter()">
  </a>

  <div class="op-filter-panel">
    <ul class="op-filter-panel--names"
        role="tablist"
        [attr.aria-label]="text.selected_filter_list"
        (keydown)="moveThroughFilterNames($event)">

      <li class="op-filter-panel--names-item">
        <button type="button"
                role="tab"
                class="op-filter-panel--name"
                id="filter-tab-search"
                aria-controls="filter-pane-search"
                [attr.aria-selected]="selectedFilterId === searchPaneId"
                [tabindex]="selectedFilterId === searchPaneId ? 0 : -1"
                (click)="selectFilter(searchPaneId)">
          <span class="op-filter-panel--name-text" [textContent]="text.filter_by_text"></span>
        </button>
      </li>

      <ng-container *ngFor="let filter of filters; trackBy: trackByName">
        <li class="op-filter-panel--names-item" *ngIf="isFilterAvailable(filter)">
          <button type="button"
                  role="tab"
                  class="op-filter-panel--name"
                  id="filter-tab-{{filter.id}}"
                  aria-controls="filter-pane-{{filter.id}}"
                  [attr.aria-selected]="selectedFilterId === filter.id"
                  [tabindex]="selectedFilterId === filter.id ? 0 : -1"
                  [attr.data-filter-name]="filter.id"
                  (click)="selectFilter(filter.id)">
            <span class="op-filter-panel--name-text" [textContent]="filter.name" [attr.title]="filter.name"></span>
            <span class="op-filter-panel--name-marker" [attr.title]="text.selected_filter_list"></span>
          </button>
        </li>
      </ng-container>

      <li class="op-filter-panel--names-item" *ngFor="let available of remainingFilters">
        <button type="button"
                role="tab"
                class="op-filter-panel--name"
                aria-selected="false"
                tabindex="-1"
                [attr.data-filter-name]="available.id"
                (click)="addFilter(available)">
          <span class="op-filter-panel--name-text" [textContent]="available.name" [attr.title]="available.name"></span>
        </button>
      </li>
    </ul>

    <div class="op-filter-panel--detail">
      <section class="op-filter-panel--pane"
               [class.-selected]="selectedFilterId === searchPaneId"
               id="filter-pane-search"
               role="tabpanel"
               aria-labelledby="filter-tab-search">
        <div class="op-filter-panel--field">
          <span class="op-filter-panel--field-label" [textContent]="text.filter_by_text"></span>
          <div class="advanced-filters--filter-value">
            <wp-filter-by-text-input
              (deactivateFilter)="deactivateFilter($event)">
            </wp-filter-by-text-input>
          </div>
        </div>
      </section>

      <ng-container *ngFor="let filter of filters; trackBy: trackByName; let index = index">
        <section *ngIf="isFilterAvailable(filter)"
                 class="op-filter-panel--pane"
                 [class.-selected]="selectedFilterId === filter.id"
                 id="filter-pane-{{filter.id}}"
                 role="tabpanel"
                 attr.aria-labelledby="filter-tab-{{filter.id}}"
                 query-filter
                 [shouldFocus]="index === focusElementIndex"
                 [filter]="filter"
                 (filterChanged)="filtersChanged.emit(filters)">
        </section>
      </ng-container>
    </div>
  </div>

  <!--
    Kept where it was, under both columns: this one is about the set of filters
    as a whole, not about whichever is selected, so it does not belong in a pane.
  -->
  <div
    *ngIf="baselineIncompatibleFilters.length > 0"
    class="op-filter-panel--notice op-toast -warning">
    <div class="op-toast--content">
      <p [textContent]="text.baseline_warning"></p>
    </div>
  </div>
</fieldset>
